import { render, staticRenderFns } from "./input-button.vue?vue&type=template&id=0a9bbc1a&"
import script from "./input-button.vue?vue&type=script&lang=js&"
export * from "./input-button.vue?vue&type=script&lang=js&"
import style0 from "./input-button.vue?vue&type=style&index=0&id=0a9bbc1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports